"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.19.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserNotificationDtoToJSON = exports.UserNotificationDtoFromJSONTyped = exports.UserNotificationDtoFromJSON = exports.instanceOfUserNotificationDto = exports.UserNotificationDtoNotificationEnum = void 0;
var runtime_1 = require("../runtime");
/**
 * @export
 */
exports.UserNotificationDtoNotificationEnum = {
    SendSalivaKit: 'SEND_SALIVA_KIT',
    ResultsReleased: 'RESULTS_RELEASED',
    PatientRequestedResult: 'PATIENT_REQUESTED_RESULT',
    PositiveNipsResult: 'POSITIVE_NIPS_RESULT',
    ReportReleased: 'REPORT_RELEASED',
    GcDocumentReleased: 'GC_DOCUMENT_RELEASED',
    NewSharedAttachment: 'NEW_SHARED_ATTACHMENT',
    PaymentSelection: 'PAYMENT_SELECTION',
    OutstandingPatientPay: 'OUTSTANDING_PATIENT_PAY',
    SampleFailureLetter: 'SAMPLE_FAILURE_LETTER'
};
/**
 * Check if a given object implements the UserNotificationDto interface.
 */
function instanceOfUserNotificationDto(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfUserNotificationDto = instanceOfUserNotificationDto;
function UserNotificationDtoFromJSON(json) {
    return UserNotificationDtoFromJSONTyped(json, false);
}
exports.UserNotificationDtoFromJSON = UserNotificationDtoFromJSON;
function UserNotificationDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'dateCreated': !(0, runtime_1.exists)(json, 'dateCreated') ? undefined : json['dateCreated'],
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'notification': !(0, runtime_1.exists)(json, 'notification') ? undefined : json['notification'],
        'relatedEntities': !(0, runtime_1.exists)(json, 'relatedEntities') ? undefined : json['relatedEntities'],
        'reqEid': !(0, runtime_1.exists)(json, 'reqEid') ? undefined : json['reqEid'],
        'requisition': !(0, runtime_1.exists)(json, 'requisition') ? undefined : json['requisition'],
        'resolvable': !(0, runtime_1.exists)(json, 'resolvable') ? undefined : json['resolvable'],
    };
}
exports.UserNotificationDtoFromJSONTyped = UserNotificationDtoFromJSONTyped;
function UserNotificationDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'dateCreated': value.dateCreated,
        'id': value.id,
        'notification': value.notification,
        'relatedEntities': value.relatedEntities,
        'reqEid': value.reqEid,
        'requisition': value.requisition,
        'resolvable': value.resolvable,
    };
}
exports.UserNotificationDtoToJSON = UserNotificationDtoToJSON;
